import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { EndpointGroupsSearchPipeModule } from '@shared/pipes/endpoint-groups';
import { GroupsPlaceholderModule } from '@shared/components/groups-placeholder';

import { EndpointGroupCheckboxesComponent } from './endpoint-group-checkboxes.component';

@NgModule({
  declarations: [EndpointGroupCheckboxesComponent],
  exports: [EndpointGroupCheckboxesComponent],
  imports: [
    CommonModule,
    NzCheckboxModule,
    NzInputModule,
    FormsModule,
    NzIconModule,
    NzSpinModule,
    EndpointGroupsSearchPipeModule,
    GroupsPlaceholderModule
  ]
})
export class EndpointGroupCheckboxesModule { }
